// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JBt20","label":"styles_label__3_Yi9"};